<mat-list class="task-list">
  <div class="task-name-row">
    <h3 class="task-list-task-name">{{ task.data.task_name }}</h3>
  </div>

  <div class="task-content">
    <div class="details-box">
      <div class="task-details-container">
        <div>
          <table>
            <tr *ngIf="task.data.details">
              <td class="align-top">
                <div class="font-light">{{ 'COMPONENT.PAGE_ORGA.details' | translate }}:</div>
              </td>
              <td>
                <span class="table-text">{{ task.data.details }}</span>
              </td>
            </tr>
            <tr>
              <td class="align-top">
                <div class="font-light">{{ 'COMPONENT.PAGE_ORGA.goalDateOn' | translate }}:</div>
              </td>
              <td>
                <span class="table-text">{{ task.data.goalDateOn | date: 'dd.MM.yy HH:mm' }}</span>
              </td>
            </tr>
            <tr>
              <td class="align-top">
                <div class="font-light">{{ 'COMPONENT.PAGE_ORGA.priority' | translate }}:</div>
              </td>
              <td>
                <span class="table-text">{{
                  'GENERAL.priority_' + task.data.priority | translate
                }}</span>
              </td>
            </tr>
            <tr>
              <td class="align-top">
                <div class="font-light">
                  {{ 'COMPONENT.PAGE_PATIENT_LIST.editor' | translate }}:
                </div>
              </td>
              <td>
                <span class="table-text"
                  >{{ task.data.contractor?.first_name }}
                  {{ task.data.contractor?.last_name }}</span
                >
              </td>
            </tr>
            <tr>
              <td class="align-top">
                <div class="font-light">{{ 'COMPONENT.PAGE_ORGA.status' | translate }}:</div>
              </td>
              <td>
                <span
                  class="status-badge"
                  [ngClass]="{ 'status-open': !task.data.done, 'status-done': task.data.done }"
                >
                  {{ task.data.done ? 'Erledigt' : 'Offen' }}
                </span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</mat-list>
